<script>
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  import { page } from "$app/stores";
  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";

  import Card from "../Card.svelte";

  export let url = "";
  export let title;
  export let description = "";

  $: isExternal = isExternalUrl(url, $page.url?.origin);
</script>

<Card
  {url}
  class="group h-full bg-white rounded-10 border border-neutral-300 box-border focus-within:ring-2 focus-within:shadow-[0_4px_0_var(--color-cyan-700)] focus-within:ring-cyan-700 focus-within:bg-cyan-50 active:shadow-card"
>
  <div class="flex flex-col items-start gap-16 p-24">
    <!-- title -->
    <a
      href={url}
      class="w-full flex justify-between items-start text-secondary leading-6 focus:outline-none group-hover:text-black focus:text-cyan-700 focus-visible:bg-transparent active:text-black"
      data-sveltekit-reload
      target={isExternal ? "_blank" : null}
      rel={isExternal ? "noopener noreferrer" : null}
      on:click={(e) => {
        e.stopPropagation();
      }}
    >
      <div class="lg:text-size-24 md:text-size-16 group-hover:underline">
        {#if isExternal}
          <ExternalLinkLabel text={title} />
        {:else}
          {title}
        {/if}
      </div>
    </a>

    <!-- description -->
    <p class="font-normal sm:line-clamp-3 md:line-clamp-10 group-hover:underline">{description}</p>
  </div>
</Card>
